var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_5056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7939 3.64706C13.3584 3.64563 14.8881 4.10823 16.1895 4.97634C17.491 5.84445 18.5057 7.07906 19.1054 8.524C19.7051 9.96893 19.8627 11.5593 19.5584 13.0938C19.2541 14.6283 18.5014 16.0381 17.3957 17.1449C16.29 18.2516 14.8809 19.0055 13.3466 19.3112C11.8124 19.617 10.2219 19.4608 8.77643 18.8624C7.33095 18.2641 6.09541 17.2505 5.22611 15.9498C4.35681 14.6491 3.89281 13.1198 3.89281 11.5554C3.9023 9.46214 4.73755 7.45722 6.21704 5.97638C7.69653 4.49554 9.70068 3.65846 11.7939 3.64706ZM11.7939 2.1665C9.93698 2.1665 8.12173 2.71715 6.57774 3.74882C5.03374 4.78048 3.83034 6.24683 3.11972 7.96242C2.4091 9.67802 2.22317 11.5658 2.58544 13.3871C2.94771 15.2083 3.84192 16.8813 5.15498 18.1943C6.46804 19.5074 8.14098 20.4016 9.96224 20.7639C11.7835 21.1262 13.6713 20.9402 15.3869 20.2296C17.1025 19.519 18.5688 18.3156 19.6005 16.7716C20.6322 15.2276 21.1828 13.4123 21.1828 11.5554C21.1828 9.0653 20.1936 6.6772 18.4329 4.91645C16.6721 3.15569 14.284 2.1665 11.7939 2.1665Z",
    fill: "#979AA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2778 24.043L19.955 18.6841L18.9294 19.7024L24.2522 25.0613C24.3191 25.1286 24.3986 25.1822 24.4861 25.2188C24.5736 25.2554 24.6675 25.2744 24.7624 25.2748C24.8573 25.2751 24.9514 25.2567 25.0392 25.2207C25.127 25.1847 25.2068 25.1318 25.2742 25.0649C25.3415 24.9981 25.395 24.9186 25.4316 24.831C25.4683 24.7435 25.4873 24.6496 25.4876 24.5547C25.488 24.4598 25.4696 24.3658 25.4336 24.278C25.3976 24.1902 25.3446 24.1103 25.2778 24.043Z",
    fill: "#979AA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_5056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLogo);
export default __webpack_public_path__ + "static/media/search-logo.6b6f0b778e2ba5371625e2bd0d68bd37.svg";
export { ForwardRef as ReactComponent };